<template>
    <div class="form">
        <div class="form__group">
            <label for="input" class="form__label">Full name</label>
            <input type="text" id="input" class="form__input" />
        </div>
        <div class="form__group">
            <label for="input" class="form__label">Full name</label>
            <input type="text" id="input" class="form__input" />
        </div>
    </div>
</template>
<script>
    export default {
        name: "Input"
    }
</script>